webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);

var _jquery = __webpack_require__(3);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var topBtn = (0, _jquery2.default)('#pagetop');
var searchBtn = (0, _jquery2.default)('#searchButton');
var headerElm = (0, _jquery2.default)('#header');
var pagetopWrp = (0, _jquery2.default)('.pagetop__wrp');
var showFlg = false;

topBtn.click(function () {
  (0, _jquery2.default)('body,html').animate({ scrollTop: 0 }, 500);
  return false;
});

searchBtn.click(function () {
  headerElm.toggleClass('-searching');
});

(0, _jquery2.default)(window).scroll(function () {
  // console.log($(window).height())
  // console.log($(this).scrollTop())
  // console.log(pagetopWrp.offset().top)
  if ((0, _jquery2.default)(this).scrollTop() > 100) {
    if (!showFlg) {
      topBtn.addClass('-fixed');
      topBtn.fadeIn();
      showFlg = true;
    }
    if ((0, _jquery2.default)(this).scrollTop() + (0, _jquery2.default)(window).height() > pagetopWrp.offset().top) {
      topBtn.removeClass('-fixed');
    } else {
      topBtn.addClass('-fixed');
    }
  } else {
    if (showFlg) {
      topBtn.fadeOut();
      showFlg = false;
    }
  }
});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[0]);


// WEBPACK FOOTER //
// static/js/bundle.js